var customPopup = {
    el: {
        closeBtn: '.btn-close',
        overlay: '#overlay'
    },
    cls: {
        activated: 'activated'
    },
    bind: function (elm) {
        var _t = this, btn = $(elm), target = $(btn.attr('data-target')), bdyCls = btn.attr('data-bdy');

        if (btn.hasClass(_t.cls['activated'])) {
            _t.destroy(elm);
        } else {
            _t.destroy(elm);
            btn.addClass(_t.cls['activated']);
            $(target).addClass(_t.cls['activated']);
            $('body').addClass(bdyCls);
            
            // Dispatch when popup opened
            stage.dispatchEvent("CustomEvent", 'CUSTOM_POPUP_OPENED', {elm: target, trigger: btn});

            // Event Listener for ajax popup loaded
            // stage.addEventListener("CustomEvent", [{ type: 'CUSTOM_POPUP_OPENED', handler: 'ON_AJAX_POPUP_LOADED' }]);                
        }
    },
    destroy: function (elm) {
        var _t = this, ths = $(elm), target = ths.attr('data-target'), bdyCls = ths.attr('data-bdy');

        $(_t.el['overlay'] + ', ' + target + ' ' + _t.el['closeBtn']).off('click').on('click', function (event) {
            event.preventDefault();
            
            ths.removeClass(_t.cls['activated']);
            $(target).removeClass(_t.cls['activated']);
            $('body').removeClass(bdyCls);
            
            // Dispatch when popup opened
            stage.dispatchEvent("CustomEvent", 'CUSTOM_POPUP_CLOSED', {elm: $(target), trigger: ths});

            // Event Listener for ajax popup loaded
            // stage.addEventListener("CustomEvent", [{ type: 'CUSTOM_POPUP_CLOSED', handler: 'ON_AJAX_POPUP_LOADED' }]);                
            
        });
    }
};